export default __webpack_public_path__ + "static/media/womens-acceries.f449e610.png";